/**
 * Feature flags — env-driven rollout toggles.
 * @type {Record<string, boolean>}
 */
export const featureFlags = {
  aiReplies: import.meta.env.VITE_FEATURE_AI_REPLIES !== 'false',
  demoPrompts: import.meta.env.VITE_FEATURE_DEMO_PROMPTS === 'true',
  streamingV2: import.meta.env.VITE_FEATURE_STREAMING_V2 === 'true',
  workspaceTimeline: import.meta.env.VITE_FEATURE_WORKSPACE_TIMELINE === 'true',
  connectionsPageV2: import.meta.env.VITE_FEATURE_CONNECTIONS_PAGE_V2 === 'true',
}

/**
 * @param {keyof typeof featureFlags} flag
 */
export function isFeatureEnabled(flag) {
  return Boolean(featureFlags[flag])
}
